import { Button, Checkbox, Form, Image, Input, InputNumber, Select, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import './EditLand.scss'
import { PlusOutlined } from '@ant-design/icons';
import LandService from '../../../service/LandService';
const { TextArea } = Input;

const formatter = value => {
    const [start, end] = `${value}`.split('.') || [];
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${end ? `${v}.${end}` : `${v}`}`;
};

const getBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

const EditLand = ({ onEdit, onClose, data }) => {
    const [form] = Form.useForm();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([])
    const [updateFileList, setUpdateFileList] = useState([])
    const [listOldFileId, setListOldFileId] = useState(data.list_image_id)

    const onFinish = values => {
        console.log('Success:', values);
        values.list_image_id = listOldFileId
        onEdit(values, updateFileList)
        onClose()
    };
    const onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };



    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const handleChange = ({ fileList: newFileList }) => {
        console.log(fileList);
        var newListImageId = []
        var newUpdateFileList = []

        for(var i = 0; i < newFileList.length; i++){
            if(newFileList[i].status == "done"){
                newListImageId.push(newFileList[i].uid)
            }
            else{
                newUpdateFileList.push(newFileList[i])
            }
        }
        setFileList(newFileList);
        setUpdateFileList(newUpdateFileList)
        setListOldFileId(newListImageId)
    }
    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Tải lên</div>
        </button>
    );

    const getListImage = (listImageId) => {
    (async () => {
      try {
        var newFileList = []
        for(var i = 0; i < listImageId.length; i++){
            var imageUrl = await LandService.getImage(listImageId[i], 'thumbnail')
            newFileList.push(
                {
                    uid: data.list_image_id[i],
                    name: `${data.list_image_id[i]}`,
                    status: 'done',
                    url: imageUrl
                }
            )
        }
        setFileList(newFileList)
      } catch (error) {
        console.log('Get image error', error);
      }
    })();
  }

    useEffect(() => {
        console.log("data edit", data)
        form.setFieldsValue(data)

        getListImage(data.list_image_id)
    }, [data])

    return (
        <div className='create-land-container'>
            <Form
                form={form}
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                // initialValues={data}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Tiêu đề"
                    name="title"
                    rules={[{ required: true, message: 'Chưa nhập tiêu đề!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Loại hình"
                    name="type"
                    rules={[{ required: true, message: 'Chưa nhập tiêu đề!' }]}
                >
                    <Select options={[
                        { value: 'SELL', label: 'Bán' },
                        { value: 'LEASE', label: 'Cho thuê' }
                    ]} />
                </Form.Item>

                <Form.Item
                    label="Giá (VNĐ)"
                    name="price"
                    rules={[{ required: true, message: 'Chưa nhập giá!' }]}
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        formatter={formatter}
                        parser={value => value?.replace(/\$\s?|(,*)/g, '')}
                    />
                </Form.Item>

                <Form.Item
                    label="Diện tích (m2)"
                    name="acreage"
                    rules={[{ required: true, message: 'Chưa nhập diện tích!' }]}
                >
                    <Input type={'number'} />
                </Form.Item>

                <Form.Item
                    label="Mặt tiền (m)"
                    name="front_length"
                    rules={[{ required: true, message: 'Chưa nhập diện tích!' }]}
                >
                    <Input type={'number'} />
                </Form.Item>

                <Form.Item
                    label="Hướng"
                    name="direction"
                    rules={[{ required: true, message: 'Chưa nhập diện tích!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Pháp lý"
                    name="legal"
                    rules={[{ required: true, message: 'Chưa nhập diện tích!' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Mô tả"
                    name="description"
                    rules={[{ required: false, message: 'Chưa nhập diện tích!' }]}
                >
                    <TextArea style={{ height: 150 }} />
                </Form.Item>

                <Upload
                    // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    multiple
                >
                    {fileList.length >= 20 ? null : uploadButton}
                </Upload>
                {previewImage && (
                    <Image
                        styles={{ root: { display: 'none' } }}
                        preview={{
                            open: previewOpen,
                            onOpenChange: visible => setPreviewOpen(visible),
                            afterOpenChange: visible => !visible && setPreviewImage(''),
                        }}
                        src={previewImage}
                    />
                )}

                <div className='create-land-command'>
                    <Button type="default" style={{ marginTop: 20 }} onClick={() => { onClose() }}>
                        Hủy
                    </Button>
                    <span className='' style={{ width: '20px', marginTop: 20 }}>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <Button type="primary" htmlType="submit">
                        Chỉnh sửa
                    </Button>
                </div>
            </Form>
            {/* <div className='create-land-item'>
            <div className='create-land-item__title'>Tiêu đề</div>
            <div className='create-land-item__input'>
                <Input></Input>
            </div>
        </div>

        <div className='create-land-item'>
            <div className='create-land-item__title'>Giá</div>
            <div className='create-land-item__input'>
                <Input></Input>
            </div>
        </div>

        <div className='create-land-item'>
            <div className='create-land-item__title'>Diện tích</div>
            <div className='create-land-item__input'>
                <Input></Input>
            </div>
        </div>

        <div className='create-land-item'>
            <div className='create-land-item__title'>Mô tả</div>
            <div className='create-land-item__input'>
                <TextArea></TextArea>
            </div>
        </div> */}
        </div>
    )
}

export default EditLand